import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { BidSimulatorPage } from '@/components/Ams/bidSimulator/BidSimulatorPage'
import {
  bidSimulatorSearchSchema,
  pruneBidSimulatorSearch,
} from '@/components/Ams/bidSimulator/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. The schema and its pruning live beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/ams/bid-simulator/')({
  validateSearch: bidSimulatorSearchSchema,
  component: BidSimulatorRoute,
})

function BidSimulatorRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <BidSimulatorPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(pruneBidSimulatorSearch, next, options))
      }
    />
  )
}
